import { Component } from  '@angular/core'

@Component({
    templateUrl: './confirm-enrollment-detail.component.html'
})
export class ConfirmEnrollmentDetailComponent {

}
